export default "__VITE_ASSET__Ceq6V9ay__"